import React, { PureComponent } from 'react'
import { func } from 'prop-types'
import withAnalytics from '../../../Analytics'
import { dotSite, dotContactPage, openData } from '../../../../config'
import './styles/Links.css'

class Links extends PureComponent {
  handleClick = ({ label }) => {
    this.props.registerOutboundLink({ label })
  }

  render() {
    return (
      <div className="links-container">
        <ul className="links">
          <li>
            <a
              href={openData}
              onClick={() => this.handleClick({ label: 'Open Data' })}
              target="_blank"
              rel="noopener noreferrer"
            >
              NYC Open Data (Parking Regulations)
            </a>
          </li>
          <li>
            <a
              href={dotSite}
              onClick={() => this.handleClick({ label: 'DOT main site' })}
              target="_blank"
              rel="noopener noreferrer"
            >
              NYCDOT
            </a>
          </li>
          <li>
            <a
              href={dotContactPage}
              onClick={() => this.handleClick({ label: 'Dot Contact Page' })}
              target="_blank"
              rel="noopener noreferrer"
            >
              Contact
            </a>
          </li>
        </ul>
      </div>
    )
  }
}

Links.propTypes = {
  registerOutboundLink: func.isRequired,
}

export default withAnalytics(Links)



// WEBPACK FOOTER //
// ./src/components/Elements/Sidebar/Links/index.jsx